import { useQuery } from "@apollo/client"
import GET_ALL_IRRIGATION_CHANNEL from "../graphql/query/GetAllIrrigationChannels"

const useIrrigationChannels = () => {
  const { data = {}, loading, refetch } = useQuery(GET_ALL_IRRIGATION_CHANNEL)
  const { getAllIrrigationChannels = null } = data
  const irrigationChannels = getAllIrrigationChannels ? getAllIrrigationChannels : []
  return { irrigationChannels, loading, refetch }
}

export default useIrrigationChannels
